import "./Courses.module.css";
import Header from "@/reusable_sections/Header";
import LegalAndProfessionalSupport from "./sections/LegalAndProfessionalSupport";
import StartYourPartnershipWithUs from "./sections/StartYourPartnershipWithUs";
import Footer from "@/reusable_sections/Footer";
export default function CoursesPage() {
  return <div>
      <Header />
      <LegalAndProfessionalSupport />
      <StartYourPartnershipWithUs />
      <Footer />
    </div>;
}